import React, { Component } from 'react'
import cx from 'classnames'

class Wrapper extends Component {
  constructor(props) {
    super(props)

    this.state = {
      x: 0,
      y: 0,
      scale: 1.0
    }

    this.dragging = false
    this.resizing = false
  }

  componentDidMount() {
    if (this.props.minimized) this.position()
  }

  componentDidUpdate(prev) {
    if (!prev.minimized && this.props.minimized) this.position()
  }

  onDown = ({ clientX, clientY }) => {
    const rect = this.container.getBoundingClientRect()
    this.offset = { x: clientX - rect.x, y: clientY - rect.y }
    this.mouse = { x: clientX, y: clientY }
    this.rect = rect
    const handleSize = 8 * this.state.scale
    if (
      this.offset.x <= handleSize ||
      this.offset.y <= handleSize ||
      rect.width - this.offset.x <= handleSize ||
      rect.height - this.offset.y <= handleSize
    ) {
      this.resizing = true
    } else {
      this.dragging = true
    }
  }

  onMove = ({ clientX, clientY }) => {
    if (this.dragging) {
      const scaleX =
        (this.rect.width * (this.state.scale - 1.0)) / (this.state.scale * 2)
      const scaleY =
        (this.rect.height * (this.state.scale - 1.0)) / (this.state.scale * 2)

      const [x, y] = [
        clientX -
          this.offset.x -
          this.container.parentNode.offsetLeft +
          scaleX -
          16,
        clientY - this.offset.y - this.container.parentNode.offsetTop + scaleY
      ]

      const { container } = this
      const { parentNode } = container
      const change = {
        x:
          x < scaleX
            ? scaleX
            : x + container.clientWidth + scaleX + 32 > parentNode.clientWidth
            ? parentNode.clientWidth - container.clientWidth - scaleX - 32
            : x,
        y:
          y < scaleY
            ? scaleY
            : y + container.clientHeight + scaleY > parentNode.clientHeight
            ? parentNode.clientHeight - container.clientHeight - scaleY
            : y
      }
      this.setState(change)
    } else if (this.resizing) {
      let [x] = [clientX - this.mouse.x, clientY - this.mouse.y]
      if (clientX - 8 > this.rect.left && clientX + 8 < this.rect.right)
        x = -Math.abs(x)
      else x = Math.abs(x)

      let scale = (this.rect.width + x) / 220
      scale = Math.max(1.0, Math.min(scale, 2.0))
      this.setState({ scale })
    }
  }

  onEnd = () => {
    this.dragging = false
    this.resizing = false
    this.offset = {}
    this.mouse = {}
    this.rect = {}
  }

  onTouchStart = (event) => {
    let clientX = event.touches[0].clientX
    let clientY = event.touches[0].clientY

    this.onDown({ clientX, clientY })

    document.addEventListener('touchmove', this.onTouchMove)
    document.addEventListener('touchend', this.onTouchEnd)
    document.addEventListener('touchcancel', this.onTouchCancel)
    event.preventDefault()
  }

  onTouchMove = (event) => {
    this.onMove({
      clientX: event.touches[0].clientX,
      clientY: event.touches[0].clientY
    })
    event.preventDefault()
  }

  onTouchEnd = (event) => {
    if (!this.dragging && !this.resizing) return
    this.onEnd()

    document.removeEventListener('touchmove', this.onTouchMove)
    document.removeEventListener('touchend', this.onTouchEnd)
    document.removeEventListener('touchcancel', this.onTouchCancel)
    event.preventDefault()
  }

  onTouchCancel = (event) => {
    if (!this.dragging && !this.resizing) return
    this.onEnd()

    document.removeEventListener('touchmove', this.onTouchMove)
    document.removeEventListener('touchend', this.onTouchEnd)
    document.removeEventListener('touchcancel', this.onTouchCancel)
    event.preventDefault()
  }

  onMouseDown = (event) => {
    let clientX = event.clientX
    let clientY = event.clientY

    this.onDown({ clientX, clientY })
    document.addEventListener('mousemove', this.onMouseMove)
    document.addEventListener('mouseup', this.onMouseUp)
    event.preventDefault()
  }

  onMouseMove = (event) => {
    let clientX = event.clientX
    let clientY = event.clientY
    this.onMove({ clientX, clientY })
    event.preventDefault()
  }

  onMouseUp = (event) => {
    if (!this.dragging && !this.resizing) return
    this.onEnd()

    document.removeEventListener('mousemove', this.onMouseMove)
    document.removeEventListener('mouseup', this.onMouseUp)
    event.preventDefault()
  }

  position = () => {
    const { container } = this
    const { parentNode } = container

    this.setState({
      x:
        parentNode.clientWidth -
        85 -
        container.clientWidth -
        ((this.state.scale - 1) * container.clientWidth) / 2 -
        10,
      y: 62
    })
  }

  render() {
    const { minimized, children } = this.props

    return (
      <div
        className={cx('gp-Media', { 'is-minimized': minimized })}
        ref={(elem) => {
          this.container = elem
        }}
        style={
          minimized
            ? {
                transform: `translate3d(${this.state.x}px, ${this.state.y}px, 0) scale(${this.state.scale})`
              }
            : {}
        }
        {...(minimized
          ? { onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }
          : {})}
      >
        {minimized && (
          <React.Fragment>
            <span className='resize-handle top' />
            <span className='resize-handle right' />
            <span className='resize-handle bottom' />
            <span className='resize-handle left' />
          </React.Fragment>
        )}
        {children}
      </div>
    )
  }
}

export default Wrapper
